import { css } from '@emotion/react';
import { t } from 'i18n';
import { DateTime } from 'luxon';
import { FlightSegment } from 'models';
import { Fragment } from 'react';

import { getFlightLayoverDuration } from '../../utils';
import { theme } from '../theme';

const styles = {
  stop: css`
    font-size: ${theme.fontSize.sm};
    margin: 0;
  `,
  airportCode: css`
    font-weight: ${theme.fontWeight.bold};
  `,
  duration: css`
    color: #727272;
  `,
};

type BoundStopsProps = {
  segmentCount: number;
  segments: FlightSegment[];
};

const getLayoverDuration = (currentSegment: FlightSegment, nextSegment: FlightSegment) => {
  const duration = getFlightLayoverDuration(currentSegment.scheduledArrivalGMT, nextSegment.scheduledDepartureGMT);
  return t('formattedTime', { hours: duration.hours, minutes: duration.minutes });
};

const formattedTime = (dateTime: string) => DateTime.fromISO(dateTime).toFormat('HH:mm');

export const BoundStops = ({ segmentCount, segments }: BoundStopsProps) => {
  if (segmentCount < 2) {
    return null;
  }

  return (
    <p css={styles.stop}>
      {segments.slice(0, segments.length - 1).map(({ arrival, id, bookingReference, scheduledArrivalLocal }, index) => (
        <Fragment key={`${id}-${bookingReference}`}>
          {arrival.cityName} <span css={styles.airportCode}>{arrival.airportCode}</span>{' '}
          {formattedTime(scheduledArrivalLocal)} - {formattedTime(segments[index + 1].scheduledDepartureLocal)}
          <span css={styles.duration}> ({getLayoverDuration(segments[index], segments[index + 1])})</span>
          {index !== segments.length - 2 ? ', ' : ' '}
        </Fragment>
      ))}
    </p>
  );
};
